import { render, staticRenderFns } from "./ProviderTable.vue?vue&type=template&id=4ed5ddaf&scoped=true&"
import script from "./ProviderTable.vue?vue&type=script&lang=js&"
export * from "./ProviderTable.vue?vue&type=script&lang=js&"
import style0 from "./ProviderTable.vue?vue&type=style&index=0&id=4ed5ddaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed5ddaf",
  null
  
)

export default component.exports